(ns teamoesterreich.user-mode.prevent.prevent-questionnaire-intro
  (:require
    [clojure.string]
    [reagent-material-ui.components :as mui]
    [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]
    [reagent-material-ui.icons.keyboard-arrow-right :refer [keyboard-arrow-right]]
    [reagent.core :as r]
    [teamoesterreich.firebase.fb-questionnaire-helper :as fq-helper]
    [teamoesterreich.store :as store]
    [teamoesterreich.user-mode.actions :as a]
    [teamoesterreich.user-mode.prevent.questionnaire-helper :as qn-helper]
    [teamoesterreich.user-mode.ui-helper.stars :as stars]
    [teamoesterreich.util.log :as log]
    [teamoesterreich.util.markdown :refer [md]]

    ))





(defn get-it []
  (fn []
    (let [selected-questionnaire-cs (r/cursor store/app-state [:state :selected-questionnaire])
          q-stars (fq-helper/get-personal-questionnaire-stars @selected-questionnaire-cs)
          questionnaire-cs (r/cursor store/app-state [:questionnaires @selected-questionnaire-cs])
          selected-question-cs (r/cursor store/app-state [:state :selected-questionnaire-question])
          ]
      (log/debug "act-questionnaire " @selected-questionnaire-cs @questionnaire-cs)
      [mui/grid
       {:container  true
        :direction  "row"
        :justify    "center"
        :alignItems "stretch"
        :spacing    1
        }

       [mui/grid
        {:container false
         :item      true
         :xs        12
         }
        ""]
       [mui/grid
        {:container false
         :item      true
         :lg        7
         :xs        11
         }

        [mui/card {:class-name "wrap-content-card"}
         [mui/card-content
          [mui/typography {:variant "h4"} (:name @questionnaire-cs)]
          [:br]
          (stars/five-stars-big q-stars)
          [:br]]
         [mui/card-content
          [:div {:dangerouslySetInnerHTML {:__html (.render md (or (:description @questionnaire-cs) ""))}
                 :style                   {:min-height "150px" :margin "20px 20px 20px 20px"}
                 :className               "content-preview-widget"}]]

         [mui/card-actions
          [mui/grid
           {:container  true
            :direction  "row"
            :justify    "center"
            :alignItems "stretch"
            :spacing    1
            }

           [mui/grid
            {:container false
             :item      true
             :md        6
             :xs        12
             }
            [mui/button
             {:variant   "contained"
              :color     "default"
              :edge      "start"
              :class     "bottom-button"
              :onClick   #(a/set-page :prevent-overview)
              :startIcon (r/as-element [keyboard-arrow-left])
              }
             "Zurück"]]
           [mui/grid
            {:container false
             :item      true
             :md        6
             :xs        12
             }

            [mui/button
             {:variant   "contained"
              :edge      "end"
              :color     "primary"
              :class     "bottom-button"
              :onClick   (fn []
                           (reset! selected-question-cs (qn-helper/get-first-uuid @questionnaire-cs))
                           (a/set-page :questionnaire-question))
              :startIcon (r/as-element [keyboard-arrow-right])
              }
             "Öffnen"]]]
          ]

         ]]

       ]
      )))

